//! DO NOT EDIT THIS FILE MANUALLY!
//! IT IS AUTO-GENERATED FROM: protos-core-geography/src/main/proto/faire/geography/locale.proto
//! RUN `yarn nx regenerate web-api` TO REGENERATE.

import { ISO3166Alpha3 } from '@faire/types-localization-api/indigofair/iso3166/ISO3166Alpha3';
import { Language } from '@faire/types-localization-api/indigofair/languages/Language';

export namespace ILocaleKey {
  /**
   * Return an instance of ILocaleKey with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<ILocaleKey>): ILocaleKey =>
    ({
      ...partial,
    }) as ILocaleKey;
}

export interface ILocaleKey {
  country: keyof typeof ISO3166Alpha3 | undefined;
  /**
   * Language codes are ISO 639-3
   */
  language: keyof typeof Language | undefined;
}
